import { TypeInterface } from "../TypeInterface";
import { Type } from "../Type";
import Translator from "../../../../../Translation/Translator";

class MainTenant extends Type implements TypeInterface  {

  public static contactForContractTypeId: number = 1;
  public static selectable: boolean = false;

  public getName(): string {
    return Translator.trans("contact-for-contract-type-main-tenant");
  }

}

export { MainTenant }
